import _findInstanceProperty from "@babel/runtime-corejs3/core-js/instance/find";
import _includesInstanceProperty from "@babel/runtime-corejs3/core-js/instance/includes";
export default {
  computed: {
    currentTabComponent() {
      var _this$tabs$find$compo, _this$tabs$find, _context;
      return (_this$tabs$find$compo = (_this$tabs$find = _findInstanceProperty(_context = this.tabs).call(_context, tab => tab.key === this.currentTab)) == null ? void 0 : _this$tabs$find.component) != null ? _this$tabs$find$compo : null;
    },
    isFullWidthTab() {
      const fullWidthTabs = ["application-form", "theme"];
      return _includesInstanceProperty(fullWidthTabs).call(fullWidthTabs, this.currentTab);
    },
    showSaveButton() {
      const tabsWithNoSave = ["disclaimers", "application-form"];
      return !_includesInstanceProperty(tabsWithNoSave).call(tabsWithNoSave, this.currentTab);
    },
    showResetVisibilitySettingsButton() {
      const applicationFormTab = ["application-form"];
      return this.currentTab == applicationFormTab;
    }
  }
};